// node modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

// assets
import CssList from './List.scss';

class UnorderedList extends PureComponent {
  static propTypes = {
    vertical: PropTypes.bool,
    inline: PropTypes.bool,
    spaceBetween: PropTypes.string,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    nowrap: PropTypes.bool,
  };

  static defaultProps = {
    vertical: false,
    inline: false,
    spaceBetween: 'default',
    className: '',
    nowrap: false,
  };

  render() {
    const { inline, nowrap, vertical, spaceBetween, className, ...more } = this.props;
    const listClassName = classNames(className, 'list', {
      'list--vertical': vertical,
      'list--inline': inline,
      'list--nowrap': nowrap,
      [`list--space-between-${spaceBetween}`]: spaceBetween,
    });

    return (
      <ul className={listClassName} {...more}>
        {this.props.children}
      </ul>
    );
  }
}

export default withStyles(CssList)(UnorderedList);
